/* DESARROLLO GENERADOR CONTRATOS VERSION 2.0 
11.SEPT.2024 
CREDITORS SON LOS ACRREDORES DE LOS CLIENTES  */
import api from './api';
import ErrorService from './errorService';
import { getConsultantIdentifier } from '../Redux/consultantUtils';

export const CreditorService = {

  getAcreedores: async () => {
    try {
      const response = await ErrorService.withTimeout(api.get('/Creditors'));
      return response.data;

    } catch (error) {
      ErrorService.handleApiError('Error al obtener acreedores:', error);
      throw error;
    }
  },
  AddCreditor: async (acreedor) => {
    try {
      //https://localhost:7178/api/Acreedores/AddCreditor
      const response = await ErrorService.withTimeout(api.post('/Acreedores/AddCreditor', {name: acreedor}));
      return response.data;
    } catch (error) {
      ErrorService.handleApiError('Error al agregar acreedor:', error);
      throw error;
    }
  },

  getLineaNegocio: async () => {
    try {
      const response = await ErrorService.withTimeout(api.get('/LineOfBusiness/'));
      return response.data;
    } catch (error) {
      ErrorService.handleApiError('Error al obtener Sucursales:', error);
      throw error;
    }
  },

  getLineaNegocioByRut: async (rutClient) => {
    try {
      const response = await ErrorService.withTimeout(api.post('/LineOfBusiness/' + rutClient));
      return response.data;
    } catch (error) {
      ErrorService.handleApiError('Error al obtener Sucursales:', error);
      throw error;
    }
  },


  getServicios: async () => {
    try {
      const response = await ErrorService.withTimeout(api.get('/Servicio'));
      return response.data;

    } catch (error) {
      ErrorService.handleApiError('Error al obtener Servicios:', error);
      throw error;
    }
  },

  getServicioby: async (IdBusiness) => {

    try {
      const response = await ErrorService.withTimeout(api.get(`/Servicio/${IdBusiness}`));
      return response.data;

    } catch (error) {
      ErrorService.handleApiError('Error al obtener Sucursales:', error);
      throw error;
    }
  },

  getCausasbyInterview: async (interviewId) => {

    try {
      const response = await ErrorService.withTimeout(api.get(`/CausasContrato/Interview/${interviewId}`));
      return response.data;

    } catch (error) {
      ErrorService.handleApiError('Error al obtener Sucursales:', error);
      throw error;
    }
  },

  getLayout: async (serviceId) => {

    try {
      const response = await ErrorService.withTimeout(api.get(`/Layout/${serviceId}`));
      return response.data;

    } catch (error) {
      ErrorService.handleApiError('Error al obtener el Layout:', error);
      throw error;
    }
  },

  getDocument: async (serviceId) => {

    try {
      const response = await ErrorService.withTimeout(api.get(`/Documents/${serviceId}`));
      return response.data;

    } catch (error) {
      ErrorService.handleApiError('Error al obtener Formato Documento:', error);
      throw error;
    }

  },

  //GUARDA EL CONTRATO - LINEAS DE NEGOCIO Y SERVICIOS.
  saveContract: async (contractData) => {
    const consultantIdentifier = getConsultantIdentifier();
    try {
      // Transformar los datos del contrato al formato esperado por la API
      const transformedData = {
        CustomerInterviewId: contractData.InterviewId,
        id: contractData.Id,
        identifier: contractData.rut,
        firstName: contractData.nombre,
        numContrato: contractData.numContratos,
        observaciones: contractData.observaciones || "",
        fechaContrato: contractData.fechaNegocio,
        create_At: new Date().toISOString(),
        update_At: new Date().toISOString(),
        CreatedBy: consultantIdentifier,
        contract_Line: contractData.negocios.map(negocio => ({
          Id: negocio.id ? negocio.id : null,
          idBusiness: negocio.lineId ? negocio.lineId : negocio.id,
          CodCtto: negocio.codCtto,
          lineOfBusinessName: negocio.name,
          contractServices: negocio.servicios.map(servicio => ({
            idService: servicio.id,
            serviceName: servicio.name,
            amount: parseInt(servicio.costo) || 0,
            causas: servicio.causas.map(causa => causa.id),
            acreedores: servicio.acreedores.map(item => ({
              Demandante: item.nombre,
              Monto: item.montoDeuda,
              CustomerInterviewId: servicio.interviewId
            })),
          }))
        }))
      };

      const response = await ErrorService.withTimeout(api.post('/Contract', transformedData));
      return response.data;
    } catch (error) {
      ErrorService.handleApiError('Error al guardar el contrato:', error);
      throw error;
    }
  },

  GetAnexoId: async (data) => {
    const consultantIdentifier = getConsultantIdentifier();
    try {
      // Transformar los datos del contrato al formato esperado por la API
      data.createdBy= consultantIdentifier
      const response = await ErrorService.withTimeout(api.post('/Contract/GetAnexoId', data));
      return response.data;
    } catch (error) {
      ErrorService.handleApiError('Error al guardar el contrato:', error);
      throw error;
    }
  },
  saveExtraAnexo: async (data) =>{
    const consultantIdentifier = getConsultantIdentifier();
    try {
      // Transformar los datos del contrato al formato esperado por la API
      data.createdBy= consultantIdentifier
      if(data.nuevoMonto==null || data.nuevoMonto ==undefined || data.nuevoMonto=="")
          data.nuevoMonto = 0
      const response = await ErrorService.withTimeout(api.post('/Contract/saveExtraAnexo', data));
      return response.data;
    } catch (error) {
      ErrorService.handleApiError('Error al guardar el contrato:', error);
      throw error;
    }
  },
}

